define('v3/Pages/Settings/Services/WebApps.Backend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function WebAppBackend () {
		BackendBase.call(this);
	};

	WebAppBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(WebAppBackend.prototype, {
		getWebApps: function () {
			return this._getJsonApi('WebApps/GetWebApps');
		},
		addWebApp: function (webApp) {
			return this._postApi('WebApps/AddWebApp', webApp);
		},
		updateWebApp: function (webApp) {
			return this._postApi('WebApps/UpdateWebApp', webApp);
		},
		deleteWebApp: function (webAppId) {
			return this._postApi('WebApps/DeleteWebApp/' + webAppId);
		},
		enableWebApp: function (webAppId, enable) {
			return this._postApi('WebApps/EnableWebApp/' + webAppId + '/' + enable);
		}

	});

	return new WebAppBackend();
});
